import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbMetaTraderWebTerminal = () => {
  return (
    <div
      className="ht__bradcaump__area__platform"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>MetaTrader Web Terminal</h1>
              <p>
                Trade directly from your browser with no downloads, no
                installations, and no limits. The Pips’ MetaTrader Web Terminal
                gives you instant access to the global markets anytime,
                anywhere.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Trading
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbMetaTraderWebTerminal.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbMetaTraderWebTerminal;
